import { css } from '@/styled-system/css';

export const miniMapContainer = css({
  // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- fixed compact map thumbnail size in property metadata rows
  width: '42px',
  // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- fixed compact map thumbnail size in property metadata rows
  height: '42px',
  // eslint-disable-next-line hotpads/no-magic-numbers -- Figma specifies a 9px radius for the mobile neighborhood thumbnail
  borderRadius: '9px',
  overflow: 'hidden',

  flexShrink: 0,
  position: 'relative',
});

export const placeholderSurface = css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1,
  backgroundColor: 'bg.softest',
});

export const mapImageOverlay = css({
  position: 'absolute',

  top: 0,

  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  filter: 'contrast(1.15)',

  zIndex: 2,
  transitionProperty: 'opacity',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-in',
});

export const mapImageHidden = css({
  opacity: 0,
});

export const mapImageVisible = css({
  opacity: 1,
});

export const pinOverlay = css({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',

  zIndex: 3,
  transitionProperty: 'opacity',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-in',
});
